import { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import { BranchPos } from './model'

/**
 * POS machine registry for the current branch. The axios instance already sends
 * `branch-id`, so both endpoints are implicitly branch-scoped.
 */
export const PosService = (client: AxiosInstance) => {
  return {
    async getBranchPos(): Promise<BranchPos[]> {
      const { data } = await wrapApiCall(() => client.get<BranchPos[]>('/branch-pos'))
      return data ?? []
    },
    /** Rejects with code POS_NOT_FOUND when the serial isn't registered here. */
    async activatePos(posId: string): Promise<BranchPos> {
      const { data } = await wrapApiCall(() =>
        client.post<BranchPos>('/branch-pos/activate', { posId })
      )
      return data
    },
  }
}
